"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcKeyValidationConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcKeyValidationConstants = (function () {
    function BcKeyValidationConstants() {
    }
    BcKeyValidationConstants.TIMER_ID = 'BcKeyValidationTimer';
    BcKeyValidationConstants.MAIN_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-key-validation");
    BcKeyValidationConstants.TIMEOUT_REMOVE_CLASSES = 201;
    BcKeyValidationConstants.NUMBER_60 = 60;
    BcKeyValidationConstants.NUMBER_10 = 10;
    BcKeyValidationConstants.NUMBER_1000 = 1000;
    BcKeyValidationConstants.DEFAULT_CONFIG = {
        timeout: 300,
        numberOfAttemps: 3,
        numberOfDigits: 6,
        expiredTitle: 'Clave expirada',
        expiredMessage: 'La clave solicitada ha expirado, por favor solicita una de nuevo.',
        getNewCodeLabel: 'Solicitar nuevo código de seguridad',
        attempsLabel: 'Intento {{current}}/{{total}}',
        loadingLabel: 'Cargando...',
        inputErrorAlert: {
            elementId: 'BcInputTokenErrorAlert',
            title: 'Error',
            description: 'Hubo un error por favor verifica la información suministrada.',
            disposable: true,
        },
        infoAlert: {
            elementId: 'BcFooterInfoAlert',
            title: 'Información',
            description: 'Esta es una alerta de información opcional para monstrar contenido de interes.',
            disposable: true,
        },
        resetOnClose: false,
    };
    BcKeyValidationConstants.ALERT_INLINE_TEXT_CLASS = 'bc-inline-alert-text';
    BcKeyValidationConstants.INPUT_TOKEN_CLASS = 'bc-input-token';
    BcKeyValidationConstants.HIDDEN_CLASS = 'bc-hidden';
    return BcKeyValidationConstants;
}());
exports.BcKeyValidationConstants = BcKeyValidationConstants;
